import INDUSTRIES from "./industries";
import SKILLS from "./skills";
import ROLES from "./roles";

const LINKS = [
  {
    value: "behance",
    label: "Behance"
  },
  {
    value: "codepen",
    label: "Codepen"
  },
  {
    value: "dribbble",
    label: "Dribbble"
  },
  {
    value: "facebook",
    label: "Facebook"
  },
  {
    value: "instagram",
    label: "Instagram"
  },
  {
    value: "linkedin",
    label: "LinkedIn"
  },
  {
    value: "stackoverflow",
    label: "Stack Overflow"
  },
  {
    value: "twitch",
    label: "Twitch"
  },
  {
    value: "twitter",
    label: "Twitter"
  },
  {
    value: "website",
    label: "Website"
  },
  {
    value: "custom",
    label: "Custom Link"
  }
];

export { INDUSTRIES, SKILLS, ROLES, LINKS };
